














import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import PullAndScroll from 'components/PullAndScroll.vue'
import ItemInfo from 'components/presenter/item/topic/viewer/Info.vue'
import ContentCourse from 'components/attendee/ItemCourse.vue'
import ContentTopic from 'components/attendee/ItemTopic.vue'
import api from 'src/assets/api/gql'
import AttendeeItemGet from 'src/graphql/attendee_item/AttendeeItemGet.gql'
import { AttendeeItem, ItemType } from 'src/graphql/types'

@Component({
  components: {
    ItemInfo,
    ContentCourse,
    ContentTopic
  }
})
export default class PageAttendeeItemContent extends Vue {
  ItemType = ItemType

  @Prop()
  readonly item!: AttendeeItem

  @Ref()
  readonly content!: PullAndScroll

  get infoSlide () {
    return {
      info: this.item?.data?.info?.text?.getText().toString(),
      files: Object.values(this.item?.data?.info?.files || {}).filter(x => (x as Json).id && !(x as Json).deleted).sort((a, b) => (a as Json).sort - (b as Json).sort) as Json[]
    }
  }

  async refresh (done: () => void) {
    await this.content.refresh(done)
  }

  async load (index: number, done: (stop?: boolean) => void) {
    await this.content.load(index, done)
  }
}
